export default [
  {
    name: "JavaScript",
    percent: 90,
  },
  {
    name: "HTML",
    percent: 90,
  },
  {
    name: "CSS",
    percent: 90,
  },
  {
    name: "SQL",
    percent: 90,
  },
  {
    name: "Java",
    percent: 90,
  },
  {
    name: "React",
    percent: 90,
  },
  {
    name: "Node.js",
    percent: 80,
  },
  {
    name: "REST",
    percent: 80,
  },
  {
    name: "Vue.js",
    percent: 50,
  },
  {
    name: "React Native",
    percent: 50,
  },
  {
    name: "Dev Ops",
    percent: 40,
  }
];
